import ConfirmModal from "../components/ConfirmModal";
import React, { useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_API_URL || "";
const tok = () => localStorage.getItem("token") || "";
const hdr = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + tok() });

export default function Payments() {
  const [confirmQR, setConfirmQR] = useState(null);
  const [qrList,      setQrList]      = useState([]);
  const [requests,    setRequests]    = useState([]);
  const [label,       setLabel]       = useState("");
  const [file,        setFile]        = useState(null);
  const [preview,     setPreview]     = useState(null);
  const [uploading,   setUploading]   = useState(false);
  const [err,         setErr]         = useState("");
  const [instructions,setInstructions]= useState("");
  const [savingInstr, setSavingInstr] = useState(false);
  const [instrSaved,  setInstrSaved]  = useState(false);
  const [tab,         setTab]         = useState("qr"); // qr | requests

  const loadQR = useCallback(async () => {
    try {
      const r = await fetch(API + "/api/payments/admin/qr", { headers: hdr() });
      setQrList(await r.json());
    } catch {}
  }, []);

  const loadRequests = useCallback(async () => {
    try {
      const r = await fetch(API + "/api/payments/admin/requests", { headers: hdr() });
      setRequests(await r.json());
    } catch {}
  }, []);

  const loadInstructions = useCallback(async () => {
    try {
      const r = await fetch(API + "/api/payments/admin/instructions", { headers: hdr() });
      if (r.ok) { const d = await r.json(); setInstructions(d.text || ""); }
    } catch {}
  }, []);

  useEffect(() => { loadQR(); loadRequests(); loadInstructions(); }, [loadQR, loadRequests, loadInstructions]);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    const reader = new FileReader();
    reader.onload = ev => setPreview(ev.target.result);
    reader.readAsDataURL(f);
  };

  const uploadQR = async () => {
    if (!label.trim() || !file) return;
    setErr(""); setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const r = await fetch(API + "/api/payments/admin/qr", {
          method: "POST", headers: hdr(),
          body: JSON.stringify({ label: label.trim(), image_base64: ev.target.result })
        });
        if (!r.ok) { setErr(await r.text()); setUploading(false); return; }
        setLabel(""); setFile(null); setPreview(null);
        await loadQR();
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch (e) { setErr(e.message); setUploading(false); }
  };

  const toggleQR = async (id) => {
    await fetch(API + `/api/payments/admin/qr/${id}`, { method: "PATCH", headers: hdr() });
    loadQR();
  };

  const deleteQR = async (id) => { setConfirmQR(id); };
  const doDeleteQR = async (id) => {
    setConfirmQR(null);
    await fetch(API + `/api/payments/admin/qr/${id}`, { method: "DELETE", headers: hdr() });
    loadQR();
  };

  const approveRequest = async (id, status) => {
    await fetch(API + `/api/payments/admin/requests/${id}`, {
      method: "PATCH", headers: hdr(),
      body: JSON.stringify({ status })
    });
    loadRequests();
  };

  const saveInstructions = async () => {
    setSavingInstr(true);
    try {
      await fetch(API + "/api/payments/admin/instructions", {
        method: "POST", headers: hdr(),
        body: JSON.stringify({ text: instructions })
      });
      setInstrSaved(true);
      setTimeout(() => setInstrSaved(false), 2000);
    } catch {}
    setSavingInstr(false);
  };

  const pendingCount = requests.filter(r => r.status === "pending").length;

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: "flex", alignItems: "center", gap: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 13, background: "linear-gradient(135deg,#b45309,#16a34a)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, boxShadow: "0 0 24px rgba(180,83,9,.35)" }}>₹</div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: "#1c1917", letterSpacing: "-.4px" }}>Payments</div>
          <div style={{ fontSize: 12, color: "#a8a29e", marginTop: 2 }}>Manage QR codes, payment instructions & fund requests</div>
        </div>
      </div>

      {/* Tabs */}
      <div className="adm-tabs" style={{ marginBottom: 22 }}>
        <button className={`adm-tab${tab === "qr" ? " active" : ""}`} onClick={() => setTab("qr")}>
          <QRIcon /> QR Codes
        </button>
        <button className={`adm-tab${tab === "instructions" ? " active" : ""}`} onClick={() => setTab("instructions")}>
          <DocIcon /> Instructions
        </button>
        <button className={`adm-tab${tab === "requests" ? " active" : ""}`} onClick={() => { setTab("requests"); loadRequests(); }}>
          <InboxIcon /> Fund Requests
          {pendingCount > 0 && <span className="adm-badge adm-badge-amber" style={{ marginLeft: 4, fontSize: 10, padding: "1px 7px" }}>{pendingCount}</span>}
        </button>
      </div>

      {/* ── QR Tab ── */}
      {tab === "qr" && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 18, alignItems: "start" }}>
          {/* Upload card */}
          <div className="adm-card adm-card-pad">
            <div style={{ fontSize: 13, fontWeight: 800, color: "#292524", marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
              <UploadIcon /> Upload New QR Code
            </div>
            {err && <div className="adm-form-err" style={{ marginBottom: 12 }}>{err}</div>}
            <div className="adm-form-row">
              <label className="adm-label">Payment Method Label</label>
              <input className="adm-input" value={label} onChange={e => setLabel(e.target.value)} placeholder="e.g. PhonePe, GPay, Paytm" />
            </div>
            <div className="adm-form-row">
              <label className="adm-label">QR Image</label>
              <label style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, border: "2px dashed rgba(255,255,255,.1)", borderRadius: 12, padding: 20, cursor: "pointer", background: preview ? "rgba(180,83,9,.04)" : "transparent", transition: "all .2s", minHeight: 140 }}>
                {preview
                  ? <img src={preview} alt="preview" style={{ maxHeight: 120, maxWidth: "100%", borderRadius: 8, objectFit: "contain" }} />
                  : <>
                      <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(180,83,9,.08)", border: "1px solid rgba(180,83,9,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}><UploadIcon color="#b45309" /></div>
                      <div style={{ fontSize: 12, color: "#a8a29e", textAlign: "center" }}>Click to choose QR image<br /><span style={{ fontSize: 11, color: "#d6d3d1" }}>PNG, JPG, WebP</span></div>
                    </>
                }
                <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />
              </label>
              {preview && <button onClick={() => { setFile(null); setPreview(null); }} style={{ marginTop: 8, fontSize: 11, color: "#dc2626", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit" }}>✕ Remove</button>}
            </div>
            <button
              onClick={uploadQR}
              disabled={uploading || !label.trim() || !file}
              className="adm-btn adm-btn-primary"
              style={{ width: "100%", justifyContent: "center", opacity: uploading || !label.trim() || !file ? .5 : 1 }}
            >
              {uploading ? "Uploading…" : "Upload QR Code"}
            </button>
          </div>

          {/* Active QRs */}
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#78716c", marginBottom: 12, textTransform: "uppercase", letterSpacing: 1, fontSize: 10 }}>Active QR Codes ({qrList.length})</div>
            {qrList.length === 0
              ? <div className="adm-card" style={{ padding: 40, textAlign: "center", color: "#d6d3d1", fontSize: 13 }}>No QR codes uploaded yet</div>
              : <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(170px,1fr))", gap: 14 }}>
                  {qrList.map(q => (
                    <div key={q.id} className="adm-card" style={{ padding: 16, textAlign: "center", border: `1px solid ${q.is_active ? "rgba(22,163,74,.2)" : "rgba(255,255,255,.07)"}` }}>
                      <img
                        src={q.image_base64}
                        alt={q.label}
                        style={{ width: "100%", maxHeight: 130, objectFit: "contain", borderRadius: 8, background: "rgba(255,255,255,.97)", padding: 6, marginBottom: 10 }}
                      />
                      <div style={{ fontSize: 13, fontWeight: 700, color: "#292524", marginBottom: 6 }}>{q.label}</div>
                      <span className={`adm-badge ${q.is_active ? "adm-badge-green" : "adm-badge-red"}`} style={{ marginBottom: 12, fontSize: 10 }}>
                        {q.is_active ? "● Active" : "○ Inactive"}
                      </span>
                      <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                        <button onClick={() => toggleQR(q.id)} className="adm-btn adm-btn-sm" style={{ flex: 1 }}>
                          {q.is_active ? "Disable" : "Enable"}
                        </button>
                        <button onClick={() => deleteQR(q.id)} className="adm-btn adm-btn-sm adm-btn-danger">
                          <TrashIcon />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
            }
          </div>
        </div>
      )}

      {/* ── Instructions Tab ── */}
      {tab === "instructions" && (
        <div className="adm-card adm-card-pad" style={{ maxWidth: 680 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#292524", marginBottom: 6, display: "flex", alignItems: "center", gap: 8 }}>
            <DocIcon /> Payment Instructions
          </div>
          <div style={{ fontSize: 12, color: "#a8a29e", marginBottom: 16 }}>
            These instructions are shown to users on the Add Fund page (below the QR code).
          </div>
          <textarea
            value={instructions}
            onChange={e => setInstructions(e.target.value)}
            rows={10}
            className="adm-input"
            style={{ resize: "vertical", lineHeight: 1.7, fontFamily: "inherit" }}
            placeholder={"1. Scan the QR code with PhonePe / GPay / Paytm\n2. Enter the exact amount\n3. Complete the payment\n4. Copy your Transaction ID\n5. Fill in the form and submit — balance is credited within minutes"}
          />
          <button
            onClick={saveInstructions}
            disabled={savingInstr}
            className="adm-btn adm-btn-primary"
            style={{ marginTop: 14 }}
          >
            {instrSaved ? "✓ Saved!" : savingInstr ? "Saving…" : "Save Instructions"}
          </button>
        </div>
      )}

      {/* ── Requests Tab ── */}
      {tab === "requests" && (
        <div className="adm-card">
          <div className="adm-card-header">
            <div className="adm-card-title"><InboxIcon /> Fund Requests</div>
            <button className="adm-btn adm-btn-sm" onClick={loadRequests}>↻ Refresh</button>
          </div>
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead><tr>
                <th>User</th><th>Amount</th><th>Method</th><th>TXN ID</th><th>Date</th><th>Status</th><th>Actions</th>
              </tr></thead>
              <tbody>
                {requests.map(r => (
                  <tr key={r.id}>
                    <td style={{ fontWeight: 700, color: "#292524" }}>{r.username}</td>
                    <td style={{ color: "#16a34a", fontWeight: 800, fontSize: 14 }}>₹{parseFloat(r.amount).toFixed(2)}</td>
                    <td>{r.payment_method || "—"}</td>
                    <td><span className="adm-mono">{r.transaction_id || "—"}</span></td>
                    <td style={{ fontSize: 11, color: "#78716c" }}>
                      {r.created_at ? new Date(r.created_at * 1000).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—"}
                    </td>
                    <td>
                      <span className={`adm-badge ${r.status === "completed" ? "adm-badge-green" : r.status === "rejected" ? "adm-badge-red" : "adm-badge-amber"}`}>
                        {r.status}
                      </span>
                    </td>
                    <td>
                      {r.status === "pending" && (
                        <div className="adm-td-actions">
                          <button onClick={() => approveRequest(r.id, "completed")} className="adm-btn adm-btn-sm adm-btn-success">✓ Approve</button>
                          <button onClick={() => approveRequest(r.id, "rejected")} className="adm-btn adm-btn-sm adm-btn-danger">✕ Reject</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                {requests.length === 0 && (
                  <tr><td colSpan="7" className="adm-empty">No fund requests yet</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <ConfirmModal
        open={!!confirmQR}
        title="Delete QR Code?"
        message="Are you sure you want to delete this QR code? This cannot be undone."
        confirmLabel="Delete"
        onConfirm={() => doDeleteQR(confirmQR)}
        onCancel={() => setConfirmQR(null)}
      />
  </div>
  );
}

function QRIcon()     { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h3v3h-3zM17 17h3v3h-3zM14 20h3"/></svg>; }
function DocIcon()    { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>; }
function InboxIcon()  { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>; }
function UploadIcon({ color = "currentColor" }) { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>; }
function TrashIcon()  { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>; }
